module.exports = __webpack_public_path__ + "img/syukyaku-kaisya-004.b061ffb8.jpg";